export default "__VITE_ASSET__CU03ElOi__"